import { getTranslate } from "@/api/apiutil";
import { TranslationResponse } from "@/libs/vulnUtil";
import { SYSTEM_ERROR } from "./util";

export const translate = (text: string) => {
  return new Promise(
    (
      resolve: (res: TranslationResponse) => void,
      reject: (err: string) => void,
    ) => {
      getTranslate(text)
        .then((res) => {
          if (res.ok === true) {
            res.json().then((json) => {
              resolve(json);
            });
          } else {
            reject("status:" + res.status);
          }
        })
        .catch(() => {
          reject(SYSTEM_ERROR);
        });
    },
  );
};
